import { render, staticRenderFns } from "./messageHistory.vue?vue&type=template&id=2b5c0a4a&"
import script from "./messageHistory.vue?vue&type=script&lang=js&"
export * from "./messageHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports